'use client';

import dynamic from 'next/dynamic';

export const RGBColorPicker = dynamic(
  () => import('./RGBColorPicker/RGBColorPicker')
);

export const HexColorPicker = dynamic(
  () => import('./HexColorPicker/HexColorPicker')
);

export const RedContrast = dynamic(() => import('./RedContrast'));

export const HSLColorsFromColorFormats = dynamic(
  () => import('./HSLColorsFromColorFormats')
);
export const LCHColors = dynamic(() => import('./LCHColors'));
export const LCHColorPicker = dynamic(
  () => import('./LCHColorPicker/LCHColorPicker')
);
export const NamedColorPicker = dynamic(
  () => import('./NamedColorPicker/NamedColorPicker')
);
export const NamedGrays = dynamic(() => import('./NamedGrays'));
